/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { AppSidebar } from "@/components/app-sidebar"
// import {
//   Breadcrumb,
//   BreadcrumbItem,
//   BreadcrumbLink,
//   BreadcrumbList,
//   BreadcrumbPage,
//   BreadcrumbSeparator,
// } from "@/components/ui/breadcrumb"

import { Separator } from "@/components/ui/separator"
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar"
import HospitalComp from "../hospital/HospitalComp"
import { useState } from "react"
import UsersComp from "../users/UsersComp"
import ApiComp from "../apis/ApiComp"
import AnalyticsComp from "../analytics/AnalyticsComp"


export default function Page() {
  // const {
  //   state,
  //   open,
  //   setOpen,
  //   openMobile,
  //   setOpenMobile,
  //   isMobile,
  //   toggleSidebar,
  // } = useSidebar()



  // console.log(open)
  

  const [open, setOpen] = useState(true)
  const [active, setActive] = useState('Hospital')
  const [analyticsTab, setAnalyticsTab] = useState('Dashboard')
  const [apiTab, setApiTab] = useState('API Details')
  
  console.log(active)
  
  // Handle analytics subsection changes
  const handleAnalyticsTabChange = (tab) => {
    setAnalyticsTab(tab)
  }

  // Handle API subsection changes
  const handleApiTabChange = (tab) => {
    setApiTab(tab)
  }
  
  return (
    <SidebarProvider>
      <AppSidebar setOpen={setOpen} setActive={setActive} setAnalyticsTab={handleAnalyticsTabChange} setApiTab={handleApiTabChange}/>
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            {/* <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem className="hidden md:block">
                  <BreadcrumbLink href="#">
                    Building Your Application
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="hidden md:block" />
                <BreadcrumbItem>
                  <BreadcrumbPage>Data Fetching</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb> */}
          </div>
        </header>
        <div style={{minWidth: "100%"}} className="flex flex-1 flex-col gap-4 p-4 pt-0">
          <div className="" style={{width: "100%"}}>
            {
              active === 'Hospital' && <HospitalComp isOpen={open}/>
            }
            {
              active === 'Users' && <UsersComp isOpen={open}/>
            }
            {
              active === 'API' && <ApiComp isOpen={open} activeTab={apiTab}/>
            }
            {
              active === 'Analytics' && <AnalyticsComp isOpen={open} activeTab={analyticsTab}/>
            }
          </div>
          
          {/* <div className="grid auto-rows-min gap-4 md:grid-cols-3">
            <div className="aspect-video rounded-xl bg-muted/50" />
            <div className="aspect-video rounded-xl bg-muted/50" />
            <div className="aspect-video rounded-xl bg-muted/50" />
          </div>
          <div className="min-h-[100vh] flex-1 rounded-xl bg-muted/50 md:min-h-min" /> */}
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
